// frontend/src/services/searchService.js
import api from './api';

export const globalSearch = async (query) => {
    if (!query || query.length < 3) return [];
    try {
        const response = await api.get('/search/global', { params: { q: query } });
        return response.data;
    } catch (error) {
        console.error('Error during global search:', error);
        return [];
    }
};